<template>
  <div
    v-if="type === 'logo_headline_custom' && main_logo"
    class="logo"
  >
    <img :alt="main_logo.alt" :src="main_logo.url" />
  </div>
  <div
    v-else
    class="logo"
    v-html="logo"
  />
</template>

<script>
import * as Logos from '@running_app_src/components/svg/logos'
import { theme_mixin } from '@/components/blocks/content-theme'

export default {
  name: 'logo',

  mixins: [theme_mixin],

  props: {
    type: String,
  },

  computed: {

    logo() {
      return Logos[this.type.replace('-','_')] || ''
    },

  },

  created() {
  },

  mounted() {
  },
}
</script>

<style lang="scss" scoped>

  .logo {
    width: min(180px, 32vw);
    max-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    :deep * {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

</style>